import type { IndexedName, UUID } from '@protector/utils/types';
import type { Colorization, LoadHeatmapParams, LoadHeatmapsSuccessType } from './heatmap.models';

export const HeatmapActionsTypes = {
  RELOAD_HEATMAPS: '[Analytics/Heatmap] Reload Heatmaps',
  RELOAD_HEATMAPS_SUCCESS: '[Analytics/Heatmap] Reload Heatmaps Success',
  RELOAD_HEATMAPS_FAILURE: '[Analytics/Heatmap] Reload Heatmaps Failure',
  LOAD_HEATMAPS: '[Analytics/Heatmap] Load Heatmaps',
  LOAD_HEATMAPS_SUCCESS: '[Analytics/Heatmap] Load Heatmaps Success',
  LOAD_HEATMAPS_FAILURE: '[Analytics/Heatmap] Load Heatmaps Failure',
  SET_HEATMAP_COLORIZATION: '[Analytics/Heatmap] Set Heatmap Colorization',
  APPLY_HEATMAP_RASTER: '[Analytics/Heatmap] Apply Heatmap Raster',
  SET_HEATMAP_LOADING: '[Analytics/Heatmap] Set Heatmap Loading',
  SET_HEATMAP_IDLE: '[Analytics/Heatmap] Set Heatmap Idle',
  CLEAR_HEATMAPS: '[Analytics/Heatmap] Clear Heatmaps'
} as const;

export interface ReloadHeatmapsModel {
  request: LoadHeatmapParams;
  retry: number;
}

export const LoadHeatmaps = (request: LoadHeatmapParams) => ({
  type: HeatmapActionsTypes.LOAD_HEATMAPS,
  payload: request
});

export const ReloadHeatmaps = (data: ReloadHeatmapsModel) => ({
  type: HeatmapActionsTypes.RELOAD_HEATMAPS,
  payload: data
});

export const LoadHeatmapsSuccess = (heatmaps: LoadHeatmapsSuccessType) => {
  return {
    type: HeatmapActionsTypes.LOAD_HEATMAPS_SUCCESS,
    payload: heatmaps
  };
};

export const LoadHeatmapsFailure = () => {
  return {
    type: HeatmapActionsTypes.LOAD_HEATMAPS_FAILURE
  };
};

export const ClearHeatmaps = () => {
  return {
    type: HeatmapActionsTypes.CLEAR_HEATMAPS
  };
};
export const SetHeatmapColorization = (colorization: Colorization) => ({
  type: HeatmapActionsTypes.SET_HEATMAP_COLORIZATION,
  payload: colorization
});

export interface ApplyHeatmapRasterPayload {
  areaId: UUID;
  url: string;
  currentHeatmap: { phenomenon: IndexedName; indicator?: IndexedName };
}

export const ApplyHeatmapRaster = (payload: ApplyHeatmapRasterPayload) => ({
  type: HeatmapActionsTypes.APPLY_HEATMAP_RASTER,
  payload
});

export const SetHeatmapLoading = (request: LoadHeatmapParams) => ({
  type: HeatmapActionsTypes.SET_HEATMAP_LOADING,
  payload: request
});

export const SetHeatmapIdle = () => ({
  type: HeatmapActionsTypes.SET_HEATMAP_IDLE
});
